import { useEffect, useState } from "react"
import DataTable from "@/widgets/DataTable"
import {
  getCoursesSimple,
} from "@/api/kuizy"
import ApproverModal from "../../widgets/ApproverModal"
import CourseApproverDetailModal from "../../widgets/CourseApproverDetailModal"

export default function CourseApproverPage() {

  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(10)
  const [search, setSearch] = useState("")

  const [selectedCourses, setSelectedCourses] = useState(new Set())

  const [modalOpen, setModalOpen] = useState(false)

  const [viewCourse, setViewCourse] = useState(null)
  const [viewModalOpen, setViewModalOpen] = useState(false)

  const fetchList = async () => {
    setLoading(true)
    try {
      const res = await getCoursesSimple({
        page,
        per_page: perPage,
        search,
      })

      setRows(res.data.rows)
      setTotal(res.data.total)
 
      setSelectedCourses(new Set())
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchList()
  }, [page, perPage])

  return (
    <div className="space-y-4">

      <h1 className="flex items-center gap-2 text-lg font-semibold">
        จัดการผู้อนุมัติข้อสอบ
      </h1>

      <div className="flex justify-end">
        <button
          disabled={selectedCourses.size === 0}
          onClick={() => setModalOpen(true)}
          className="bg-primary text-white px-4 py-2 rounded-lg disabled:opacity-50"
        >
          กำหนดผู้อนุมัติ
        </button>
      </div>

      <div className="flex gap-3 items-center bg-white p-4 rounded-xl shadow-sm">
        <input
          placeholder="ค้นหาชื่อหลักสูตร หรือ ชื่อย่อหลักสูตร"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (setPage(1), fetchList())}
          className="flex-1 border border-gray-300 rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-primary"
        />

        <button
          onClick={() => { setPage(1); fetchList() }}
          className="bg-primary hover:bg-secondary text-white px-4 py-2 rounded-lg text-sm"
        >
          ค้นหา
        </button>
      </div>

      <DataTable
        columns={[
          { key: "name", title: "ชื่อหลักสูตร" },
          { key: "code", title: "ชื่อย่อหลักสูตร" },
          {
            key: "approver_count",
            title: "จำนวนผู้อนุมัติ",
            align: "center",
            render: (row) => (
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  setViewCourse(row)
                  setViewModalOpen(true)
                }}
                className="text-primary font-semibold hover:underline"
              >
                {row.approver_count || 0}
              </button>
            )
          }
        ]}
        rows={rows}
        loading={loading}
        selectable
        selectedSet={selectedCourses}
        onToggleRow={(key) => {
          const newSet = new Set(selectedCourses)
          newSet.has(key) ? newSet.delete(key) : newSet.add(key)
          setSelectedCourses(newSet)
        }}
        rowKey={(row) => row.id}
        page={page}
        perPage={perPage}
        total={total}
        onPageChange={setPage}
        onPerPageChange={(val) => {
          setPage(1)
          setPerPage(val)
        }}
      />

      {/* 📦 Bulk Modal */}
      <ApproverModal
        visible={modalOpen}
        courseIds={[...selectedCourses]}
        onClose={() => {
          setModalOpen(false)
          fetchList()
        }}
      />

      {/* 📦 Single Course Modal */}
      <CourseApproverDetailModal
        visible={viewModalOpen}
        courseId={viewCourse?.id}
        courseName={viewCourse?.name}
        onClose={() => {
          setViewModalOpen(false)
          setViewCourse(null)
          fetchList()
        }}
      />

    </div>
  )
}
